import React from 'react';
import docDesignerHOC from '../docDesigner';

function Invoices() {
	return <div className="doc-designer">Invoices Design</div>;
}

const designerHOC = docDesignerHOC(Invoices);

export default designerHOC;
